import React, { Component } from "react";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import * as WOTActionType from "../../Work-Order-Type/constants";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as LotActionType from "../../Lots/constants";
import * as TradeActionType from "../../Trades/constants";
import * as ItemActionType from "../../Items/constants";
import * as SubcontractorActionType from "../../Subcontractors/constants";
import * as ProjectActionType from "../../Projects/constants";
import * as RFSActionType from "../constants";
let counter = 1;

class UpdateSelectedWO extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    toggleModal: PropTypes.func,
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    workOrderTypeList: PropTypes.any,
    TradeList: PropTypes.any,
    ItemRepairList: PropTypes.any,
    ProblemList: PropTypes.any,
    RoomList: PropTypes.any,
    SubcontractorList: PropTypes.any,
    UserList: PropTypes.any,
    ManagerStore: PropTypes.object,
    IsRedirectToEdit: PropTypes.object,
    ManageWorkOrderTypes: PropTypes.object,
    UserProfile: PropTypes.object,
    DefaultConfigList: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      isModeAssignSub: true,
      isLoadingWorkOrderType: false,
      isFetchTrade: false,
      check: false,
      wot: null,
      trade: null,
      itemRepair: null,
      problem: null,
      room: null,
      subcontractor: null,
      user: null,
      userList: [],
      isLoadingTrade: false,
      isLoadingItemToRepair: false,
      isLoadingProblem: false,
      isLoadingSubcontractor: false,
      isDisabled: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.TradeList) {
      this.setState({ isLoadingTrade: false });
    }
    if (nextProps.SubcontractorList) {
      this.setState({ isLoadingSubcontractor: false });
    }
    if (nextProps.UserList) {
      this.setState({ isLoadingUser: false });
    }
    if (nextProps.ItemRepairList) {
      this.setState({ isLoadingItemToRepair: false });
    }
    if (nextProps.ProblemList) {
      this.setState({ isLoadingProblem: false });
    }
    if (nextProps.workOrderTypeList) {
      this.setState({ isLoadingWorkOrderType: false });
    }
  }

  fetchUser = () => {
    this.setState({ isLoadingUser: true });
    this.props.dispatch({
      type: ProjectActionType.GET_LIST_USER_ASYNC,
      params: {
        projectId: this.props.ManagerStore.RFSProfile.project.id,
      },
      callback: () => {
        this.setState({ isFetchedUser: true });
      },
    });
  };

  fetchSelectTrade = () => {
    this.setState({ isLoadingTrade: true });
    this.props.dispatch({
      type: LotActionType.SELECT_TRADE_ASYNC,
      params: {
        id: this.props.ManagerStore.RFSProfile.lot.id,
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
      },
    });
  };

  fetchSelectProblem = () => {
    if (this.state.itemRepair) {
      this.setState({ isLoadingProblem: true });
      this.props.dispatch({
        type: ItemActionType.SELECT_LIST_PROBLEM_ASYNC,
        params: {
          id: this.state.itemRepair.value,
          searchKey: "",
        },
      });
    }
  };

  fetchSelectedWOT = () => {
    this.setState({ isLoadingWorkOrderType: true });
    this.props.dispatch({
      type: WOTActionType.SELECT_LIST_WOT_ASYNC,
      params: {
        searchKey: "",
        selectedValue: "",
        setDefaultSelected: false,
        wot: null,
      },
    });
  };

  fetchSelectItemRepair = () => {
    if (this.state.trade) {
      this.setState({ isLoadingItemToRepair: true });
      this.props.dispatch({
        type: TradeActionType.SELECT_LIST_ITEM_REPAIR_BY_TRADEID_ASYNC,
        params: {
          id: this.state.trade.value,
          searchKey: "",
          selectedValue: "",
          setDefaultSelected: false,
        },
      });
    }
  };

  fetchSubcontractor = () => {
    if (this.state.trade) {
      this.setState({ isLoadingSubcontractor: true });
      this.props.dispatch({
        type: SubcontractorActionType.SELECT_LIST_SUBCONTRACTOR_ASYNC,
        params: {
          projectId: this.props.ManagerStore.RFSProfile.project.id,
          lotId: this.props.ManagerStore.RFSProfile.lot.id,
          tradeId: this.state.trade.value,
          param: {
            searchKey: "",
            selectedValue: "",
          },
        },
      });
    }
  };

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value,
    });
    if (name === "wot") {
      this.updateValues(event, "workOrderType");
    }
    if (name === "subcontractor") {
      this.updateValues(event, "subcontractorProfile");
    }
    if (name === "problem") {
      this.updateValues(event, name);
    }
    if (name === "user") {
      this.updateValues(event, "assignedUser");
    }

    if (name === "itemRepair") {
      // const updatedITR = {
      //   description: event.value.name,
      //   id: event.value.id
      // };
      this.updateValues(event, "itemToRepair");
      this.setState({
        problem: null,
      });
    }
    if (name === "trade") {
      this.updateValues(event, name);
      this.setState({
        subcontractor: null,
        itemRepair: null,
        problem: null,
      });
    }
  };

  // updateValues = (event, name) => {
  //   console.log("Removed value", this.props.ManagerStore);
  //   let newArr = [...this.props.ManagerStore.updatedValueForFilterWO];
  //   const fieldName = name;
  //   let found = false;
  //   if (event.value !== null) {
  //     for (let i = 0; i < newArr.length; i++) {
  //       console.log('assignedUserOfSubcontractor', newArr[i], fieldName)
  //       if (newArr[i].fieldName === fieldName) {
  //         newArr[i].value = event.value.value;
  //         newArr[i].text = event.value.text;
  //         found = true;
  //         break; // Exit the loop since you found a match
  //       }
  //     }

  //     if (!found) {
  //       newArr.push({ ...event.value, fieldName });
  //       console.log('Not found', newArr)
  //     }
  //   } else {
  //     newArr.filter((item) => item.fieldName !== name);
  //   }
  //   console.log("updated newArr", newArr);

  //   this.props.dispatch({
  //     type: RFSActionType.UPDATED_FILTER_VALUE_FOR_WO,
  //     payload: newArr,
  //     callback: (data) => {
  //       console.log("Filter WOs", this.props.ManagerStore, data);
  //     },
  //   });
  // };
  updateValues = (event, name) => {
    let newArr = [...this.props.ManagerStore.updatedValueForFilterWO];
    const fieldName = name;
    let selectedValue = {
      value: event.value ? event.value.value : "",
      text: event.value ? event.value.text : "",
      fieldName: name,
    };
    console.log("updatedValueForFilterWO", newArr);
    newArr.forEach((item, index) => {
      console.log("matching para", item.fieldName, fieldName);
      if (item.fieldName === fieldName) {
        newArr[index] = selectedValue;
      }
    });
    console.log("New arr", newArr, selectedValue);
    this.props.dispatch({
      type: RFSActionType.UPDATED_FILTER_VALUE_FOR_WO,
      payload: newArr,
      callback: (data) => {
        console.log("Filter WOs", this.props.ManagerStore, data);
      },
    });
  };
  handleModeAssign = (mode) => {
    let updatedValueForFilterWO = [
      ...this.props.ManagerStore.updatedValueForFilterWO,
    ];
    let newUpdatedValues = [];
    if (mode === "assignedUser") {
      this.setState({ isModeAssignSub: false, subcontractor: null });
      newUpdatedValues = updatedValueForFilterWO.map((item) => {
        console.log("subcontractorProfile", item.fieldName);
        if (item.fieldName === "subcontractorProfile") {
          // Create a new object without value and text properties
          const updatedItem = { ...item };
          updatedItem.value = "";
          updatedItem.text = "";
          return updatedItem;
        }
        return item;
      });
    } else {
      this.setState({ isModeAssignSub: true, user: null });
      newUpdatedValues = updatedValueForFilterWO.map((item) => {
        if (item.fieldName === "assignedUser") {
          // Create a new object without value and text properties
          const updatedItem = { ...item };
          updatedItem.value = "";
          updatedItem.text = "";
          return updatedItem;
        }
        return item;
      });
    }
    this.props.dispatch({
      type: RFSActionType.UPDATED_FILTER_VALUE_FOR_WO,
      payload: newUpdatedValues,
    });
  };

  render() {
    return (
      <div style={{ marginBottom: "10px" }}>
        <p
          className="text-danger"
          style={{ marginTop: "15px", marginLeft: "20px", fontSize: "15px" }}
        >
          Disclaimer: All below fields will be updated for the selected Work
          Orders, and any field kept blank will be updated as empty even for the
          Work Order that already had values.{" "}
        </p>
        <div className="row" style={{ marginTop: "15px" }}>
          <div className="col-sm-6">
            <label
              className="col-sm-12 col-xs-12 control-label form-siteone-label"
              style={{
                padding: 0,
                marginLeft: 25,
              }}
            >
              Work order type<span className="text-danger"> *</span>
            </label>
            <div className="col-sm-12">
              <Dropdown
                onChange={(ref) => {
                  this.onSelectChange(ref, "wot");
                }}
                className="filestring-dropdown filter-dropdown"
                onRemote={this.fetchSelectedWOT}
                options={this.props.workOrderTypeList}
                loading={this.state.isLoadingWorkOrderType}
                optionLabel="text"
                errorMessage="This information is required."
                value={this.state.wot}
                showClear={true}
                name="workOrderType"
                placeholder="-- Please select"
                ref={(ref) => {
                  this.wotDropdown = ref;
                }}
                style={{ width: "100%", paddingLeft: 15 }}
              />
            </div>
          </div>
        </div>

        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-sm-12 col-xs-12">
            <label
              className="col-sm-12 col-xs-12 control-label form-siteone-label"
              style={{
                padding: 0,
                marginLeft: 25,
              }}
            >
              Trade<span className="text-danger"> *</span>
            </label>
            <div className="col-sm-12 col-xs-12">
              <Dropdown
                onChange={(ref) => {
                  this.onSelectChange(ref, "trade");
                }}
                filter={true}
                className="filestring-dropdown filter-dropdown"
                options={this.props.TradeList}
                optionLabel="text"
                errorMessage="This information is required."
                onRemote={this.fetchSelectTrade}
                value={this.state.trade}
                loading={this.state.isLoadingTrade}
                showClear={true}
                name="trade"
                placeholder="-- Please select"
                ref={(ref) => {
                  this.tradeDropdown = ref;
                }}
                style={{
                  width: "100%",
                  paddingLeft: 10,
                  margin: 0,
                }}
              />
            </div>
          </div>

          <div className="col-sm-12 col-xs-12 select-assigned">
            <div
              className="col-sm-12 control-label form-siteone-label"
              style={{ marginBottom: 5 }}
            >
              Assigned to: <span className="text-danger"> *</span>
              <div
                className="btn-group btn-group-sm wo-assign-btn-group"
                role="group"
              >
                <button
                  style={{
                    backgroundColor: this.state.isModeAssignSub
                      ? "#4267b2"
                      : "",
                    color: this.state.isModeAssignSub ? "#fff" : "",
                  }}
                  type="button"
                  className={
                    "btn btn-secondary " +
                    (this.state.isModeAssignSub ? "active hover" : "")
                  }
                  onClick={() => {
                    this.handleModeAssign("subcontractor");
                  }}
                >
                  subcontractor
                </button>
                <button
                  style={{
                    backgroundColor: !this.state.isModeAssignSub
                      ? "#4267b2"
                      : "",
                    color: !this.state.isModeAssignSub ? "#fff" : "",
                  }}
                  type="button"
                  className={
                    "btn btn-secondary " +
                    (!this.state.isModeAssignSub ? "active hover" : "")
                  }
                  onClick={() => {
                    this.handleModeAssign("assignedUser");
                  }}
                >
                  internal user
                </button>
              </div>
            </div>
            <div className="col-sm-12 col-xs-12">
              {this.state.isModeAssignSub ? (
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "subcontractor");
                  }}
                  filter={true}
                  className="filestring-dropdown filter-dropdown"
                  onRemote={this.fetchSubcontractor}
                  options={this.state.trade ? this.props.SubcontractorList : []}
                  optionLabel="text"
                  errorMessage="This information is required."
                  value={this.state.subcontractor}
                  loading={this.state.isLoadingSubcontractor}
                  disabled={!this.state.trade}
                  showClear={true}
                  name="subcontractor"
                  placeholder="-- Select a trade first"
                  ref={(ref) => {
                    this.subcontractorDropdown = ref;
                  }}
                  style={{
                    width: "100%",
                    paddingLeft: 10,
                    margin: 0,
                  }}
                />
              ) : (
                <Dropdown
                  onChange={(ref) => {
                    this.onSelectChange(ref, "user");
                  }}
                  filter={true}
                  className="filestring-dropdown filter-dropdown"
                  onRemote={this.fetchUser}
                  options={
                    this.state.isFetchedUser
                      ? this.props.UserList.map((item) => {
                          return {
                            ...item,
                            text: `${item.text} (${item.extensionValue.email})`,
                          };
                        })
                      : [{ ...this.state.user }]
                  }
                  loading={this.state.isLoadingUser}
                  optionLabel="text"
                  errorMessage="This information is required."
                  value={this.state.user}
                  showClear={true}
                  name="user"
                  placeholder="-- Select a user"
                  ref={(ref) => {
                    this.userDropdown = ref;
                  }}
                  style={{
                    width: "100%",
                    paddingLeft: 10,
                    margin: 0,
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: "20px" }}>
          <div className="col-sm-12 col-xs-12">
            <label
              className="col-sm-12 col-xs-12 control-label form-siteone-label"
              style={{
                padding: 0,
                marginLeft: 25,
              }}
            >
              Item to repair<span className="text-danger"> *</span>
            </label>
            <div className="col-sm-12 col-xs-12">
              <Dropdown
                onChange={(ref) => {
                  this.onSelectChange(ref, "itemRepair");
                }}
                filter={true}
                className="filestring-dropdown filter-dropdown"
                options={this.state.trade ? this.props.ItemRepairList : []}
                optionLabel="text"
                errorMessage="This information is required."
                onRemote={this.fetchSelectItemRepair}
                loading={this.state.isLoadingItemToRepair}
                value={this.state.itemRepair}
                disabled={!this.state.trade}
                showClear={true}
                name="itemToRepair"
                placeholder="-- Select a trade first"
                ref={(ref) => {
                  this.itemRepairDropdown = ref;
                }}
                style={{
                  width: "100%",
                  paddingLeft: 10,
                  margin: 0,
                }}
              />
            </div>
          </div>

          <div className="col-sm-12 col-xs-12">
            <label
              className="25 control-label form-siteone-label"
              style={{
                padding: 0,
                marginLeft: 25,
              }}
            >
              Problem<span className="text-danger"> *</span>
            </label>
            <div className="col-sm-12 col-xs-12">
              <Dropdown
                onChange={(ref) => {
                  this.onSelectChange(ref, "problem");
                }}
                className="filestring-dropdown filter-dropdown"
                options={this.state.itemRepair ? this.props.ProblemList : []}
                optionLabel="text"
                errorMessage="This information is required."
                onRemote={this.fetchSelectProblem}
                loading={this.state.isLoadingProblem}
                value={this.state.problem}
                disabled={!this.state.itemRepair}
                showClear={true}
                name="problem"
                ref={(ref) => {
                  this.problemDropdown = ref;
                }}
                placeholder="-- Select an item to repair first"
                style={{
                  width: "100%",
                  paddingLeft: 10,
                  margin: 0,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    workOrderTypeList: state.WorkOrderTypesStore.WOTList,
    TradeList: state.LotStore.TradeList,
    ManagerStore: state.RFSStore,
    ItemRepairList: state.TradeStore.ItemRepairList,
    ProblemList: state.ItemRepairStore.ProblemList,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    UserList: state.ProjectStore.UserSelectList,
  };
};

export default connect(mapStateToProps)(UpdateSelectedWO);



// WEBPACK FOOTER //
// ./src/Request-Services/Components/UpdateSelectedWO.js